import script from "./ScheduleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleCard.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleCard.vue?vue&type=style&index=0&id=2844ed60&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2844ed60"]])

export default __exports__